import React, { useContext, useEffect } from "react";
import { Route, Redirect, useLocation, useHistory } from "react-router-dom";

import Chip from "@material-ui/core/Chip";

import { AuthContext } from "../context/states/authState";

export default function AuthenticatedRoute({
  children,
  roles,
  permission,
  ...rest
}) {
  const { pathname, search } = useLocation();

  const history = useHistory();

  const {
    isAuthenticated,
    authHandler,
    currentUser,
    authChecked,
    permissionKeys,
  } = useContext(AuthContext);

  useEffect(() => {
    if (!authChecked) {
      authHandler();
    }

    // console.log("CURRENT USER", currentUser);
    // console.log("ROLES", roles);

    // console.log({
    //   isAuthenticated,
    //   currentUser,
    //   role: currentUser?.role,
    //   permission,
    //   permissionKeys,
    // });

    // eslint-disable-next-line
  }, []);

  // WAIT UNTIL AUTH FINISHES
  if (!authChecked) {
    return <div>Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={() => {
        // NOT LOGGED IN
        if (!isAuthenticated) {
          return <Redirect to={`/?redirect=${pathname}${search}`} />;
        }

        // ROLE CHECK
        if (roles && roles.indexOf(currentUser?.role || "") === -1) {
          return (
            <Chip
              size="small"
              label="Access denied"
              onDelete={() => history.goBack()}
              color="secondary"
            />
          );
        }

        // PERMISSION CHECK
        if (
          permission &&
          permissionKeys.length > 0 &&
          !permissionKeys.includes(permission)
        ) {
          return (
            <Chip
              size="small"
              label="You don't have permission to access this page"
              onDelete={() => history.goBack()}
              color="secondary"
            />
          );
        }

        // ONLY RENDER COMPONENT HERE
        return children;
      }}
    />
  );
}
